const doc = [({"da":({"js":({"layout":({"top_nav":({"you_were_signed_out":"Du blev logget ud"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;